import { createContext } from 'react'

export type ThemeValue = 'light' | 'dark' | 'system'

export type ThemeContextType = {
  themeValue: ThemeValue
  setThemeValue: (value: ThemeValue) => void
  currentMode: 'light' | 'dark'
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)
